import Projects from './actions/projects';
import ControlPoints from './actions/control_points';
import ControlPointRequests from './actions/control_point_requests';
import Attachments from './actions/attachments';
import Notifications from './actions/notifications';

const actions = {
  ...Projects,
  ...ControlPoints,
  ...ControlPointRequests,
  ...Attachments,
  ...Notifications,
  async openControlPointByID(store, controlPointID) {
    const { commit, dispatch } = store;
    try {
      const controlPoint = await dispatch('getControlPointByID', controlPointID);
      commit('setControlPointModal', true);
      return Promise.resolve(controlPoint);
    } catch(err) {
      return Promise.reject(err);
    }
  },
  async openControlPointRequestByID(store, controlPointRequestID) {
    const { commit, dispatch } = store;
    try {
      const controlPointRequest = await dispatch('getControlPointRequestByID', controlPointRequestID);
      commit('setControlPointRequestModal', true);
      return Promise.resolve(controlPointRequest);
    } catch(err) {
      return Promise.reject(err);
    }
  },
  async openNotificationByID(store, notificationID) {
    const { commit, dispatch } = store;
    try {
      const notification = await dispatch('getNotificationByID', notificationID);
      commit('setNotificationModal', true);
      return Promise.resolve(notification);
    } catch(err) {
      return Promise.reject(err);
    }
  },
};

export default actions;
